import Icon from '../components/Icon';

const ImageSlash = Icon(
  'image-slash',
  <>
    <path
      fillRule="evenodd"
      d="M2.53 1.47a.75.75 0 0 0-1.06 1.06L2.6 3.662a2.74 2.74 0 0 0-.351 1.336V19A2.75 2.75 0 0 0 5 21.75h14c.482 0 .942-.124 1.34-.349l1.13 1.13a.75.75 0 1 0 1.06-1.061L4.123 3.062l-.004-.004zm1.233 3.354A1 1 0 0 0 3.75 5v10.243l1.631-1.631a2.25 2.25 0 0 1 3.177-.005l1.968 1.955 1.99-1.987-3.372-3.371a1.5 1.5 0 0 1-2.099-2.099zM3.75 19v-1.635l2.692-2.692a.75.75 0 0 1 1.059-.001l2.498 2.482a.75.75 0 0 0 1.059-.002l2.518-2.515 5.601 5.6a1 1 0 0 1-.177.013H5A1.25 1.25 0 0 1 3.75 19"
      clipRule="evenodd"
    />
    <path d="M8.25 3A.75.75 0 0 1 9 2.25h10A2.75 2.75 0 0 1 21.75 5v10a.75.75 0 0 1-1.382.404l-3.21-3.203a.75.75 0 1 1 1.06-1.061l2.032 2.027V5A1.25 1.25 0 0 0 19 3.75H9A.75.75 0 0 1 8.25 3" />
  </>
);

export default ImageSlash;
